export function detectLocale() {
  let lang = window.navigator.languages ? window.navigator.languages[0] : null;
  lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
  if (lang.indexOf('-') !== -1)
    lang = lang.split('-')[0];
  if (lang.indexOf('_') !== -1)
    lang = lang.split('_')[0];
  lang = lang === 'da' ? 'da' : 'en';

  if (window.localStorage) {
    let lslang = window.localStorage.getItem('locale');
    if (lslang === 'da' || lslang === 'en') {
      lang = lslang;
    }
  }
  return lang;
}

export function changeLocale(locale) {
  if (!locale) {
    locale = detectLocale();
  }
  if (window.localStorage) {
    window.localStorage.setItem('locale', locale);
  }
  if (window._chatlio) {
    if (locale === 'en') {
      window._chatlio.configure({
        'onlineTitle': 'How can we help you?',
        'offlineTitle': 'Contact Us',
        'agentLabel': 'ONLINECITY.IO Support',
        'onlineMessagePlaceholder': 'Type message here...',
        'offlineGreeting': 'Sorry we are away, but we would love to hear from you and chat soon!',
        'offlineEmailPlaceholder': 'Email',
        'offlineMessagePlaceholder': 'Your message here',
        'offlineNamePlaceholder': 'Name (optional but helpful)',
        'offlineSendButton': 'Send',
        'offlineThankYouMessage': 'Thanks for your message. We will be in touch soon!',
        'autoResponseMessage': 'Question? Just type it below and we are online and ready to answer.'
      });
    } else {
      window._chatlio.configure({
        'onlineTitle': 'Kan vi hjælpe?',
        'agentLabel': 'ONLINECITY.IO Support',
        'onlineMessagePlaceholder': 'Skriv din besked her...',
        'offlineGreeting': 'Vi er desværre ikke online på support chatten. Skriv endelig din besked, så vender vi tilbage hurtigst muligt.',
        'offlineEmailPlaceholder': 'Email',
        'offlineMessagePlaceholder': 'Skriv din besked her...',
        'offlineNamePlaceholder': 'Name (optional but helpful)',
        'offlineSendButton': 'Send',
        'offlineThankYouMessage': 'Tak for din besked. Vi kontakter dig hurtigst muligt!',
        'autoResponseMessage': 'Har du spørgsmål til vores produkter eller brug for support? Vi sidder klar til at hjælpe dig.'
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/multilanguage/locale.js